//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import verzekeraars from '~/graphql/queries/verzekeraars.gql';

export default {
  apollo: {
    verzekeraars: {
      query: verzekeraars,
    },
  },
  props: {
    filter: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  data: () => ({
    /** @type {Array<{title: string, active_image: string, vergoedingen: Array<{title: string, vergoeding: string, bijzonderheden: string|null}>}>} */
    verzekeraars: [],
    sortBy: 'verzekeraar_title',
    sortDirection: 'desc',
  }),
  computed: {
    /** @returns {Array<{title: string, vergoeding: string, bijzonderheden: string|null, verzekeraar: {naam: string, image: string}}>} */
    filteredVerzekeringen() {
      return this.sortedVerzekeringen.filter(this.verzekeringFilter);
    },
    sortedVerzekeringen() {
      if (!this.verzekeraars) {
        return [];
      }

      const verzekeraars = JSON.parse(JSON.stringify(this.verzekeraars));

      return verzekeraars.sort((a, b) => {
        let nameA, nameB;
        if (this.sortBy === 'verzekeraar_title') {
          nameA = a.title?.toLowerCase();
          nameB = b.title?.toLowerCase();
        } else {
          nameA = a.vergoedingen.map(vergoeding => vergoeding[this.sortBy]).join(' ')?.toLowerCase() ?? '-';
          nameB = b.vergoedingen.map(vergoeding => vergoeding[this.sortBy]).join(' ')?.toLowerCase() ?? '-';
        }
        if (nameA < nameB) {
          return this.sortDirection === 'asc' ? 1 : -1;
        }
        if (nameA > nameB) {
          return this.sortDirection === 'asc' ? -1 : 1;
        }
        return 0;
      });
    },
    sortIcon() {
      return ['far', (this.sortDirection === 'asc' ? 'sort-up' : 'sort-down')];
    },
  },
  methods: {
    /** @param {{title: string, vergoeding: string, bijzonderheden: string|null, verzekeraar: {naam: string, image: string}}} verzekering */
    verzekeringFilter(verzekering) {
      const filter = this.filter?.toLowerCase();
      return !filter ||
        verzekering.title.toLowerCase().includes(filter) ||
        verzekering.vergoedingen.map((vergoeding) => { return vergoeding.vergoeding; }).join(' ').toLowerCase().includes(filter) ||
        verzekering.vergoedingen.map((vergoeding) => { return vergoeding.bijzonderheden; }).join(' ')?.toLowerCase().includes(filter);
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      }
      this.sortBy = s;
    },
  },
};
